import { Combobox, type SelectOption } from '@hue/design-system';

/// Fornecedores, ofertas, pedidos e produtos crescem com a empresa: escolher é digitar e achar. O
/// valor vazio (`emptyValue`) é o "nenhum" ou o "todos" da lista, e limpar o campo volta a ele.
export function PickField({
  label,
  placeholder,
  value,
  emptyValue = '',
  options,
  onChange,
  error,
  disabled,
}: {
  label: string;
  placeholder: string;
  value: string;
  emptyValue?: string | undefined;
  options: SelectOption[];
  onChange: (value: string) => void;
  error?: string | undefined;
  disabled?: boolean | undefined;
}) {
  const choices = options.filter((option) => option.value !== emptyValue);
  return (
    <Combobox
      label={label}
      placeholder={placeholder}
      selectedLabel={
        value === emptyValue ? '' : (choices.find((option) => option.value === value)?.label ?? '')
      }
      options={choices}
      error={error}
      disabled={disabled}
      onClear={() => onChange(emptyValue)}
      onSelect={(choice) => {
        if (choice.kind === 'option') onChange(choice.value);
      }}
    />
  );
}
